import { useState, useEffect } from 'react'
import RenderComponent from '../components/renderComponent';
import { useSearchParams } from 'react-router-dom';

function FinalPixelPage({lang}) {

    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [meta, setMeta] = useState({ title: '', description: '' });

    const [searchParams] = useSearchParams();
    const preview = searchParams.get('preview');

    useEffect(() => {
        const fetchPage = async () => {

            try {
                const res = await fetch("/api/get-content", {
                    method: "GET",
                    headers: {
                        "ContentType": "pageFinalPixel",
                        "Lang": lang,
                        "Preview": preview,
                    },
                });
                const result = await res.json();

                if (result.data) {
                    setPageData(result.data);
                    setMeta({
                        title: result?.data?.metaTitle || "Eyeline | Final Pixel",
                        description: result?.data?.metaDescription || 'Eyeline Final Pixel',
                    });
                } else {
                    setPageData(null);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }

        };

        fetchPage();

    }, [lang]);

    useEffect(() => {
        if (meta.title) {
            document.title = meta.title;
        }

        if (meta.description) {
        let descTag = document.querySelector('meta[name="description"]');

        if (!descTag) {
            descTag = document.createElement('meta');
            descTag.setAttribute('name', 'description');
            document.head.appendChild(descTag);
        }

        descTag.setAttribute('content', meta.description);
        }

    }, [meta]);


    if (pageData)

    return (
        <>
            <RenderComponent sections={pageData.pageSections} />


        </>


    )

}

export default FinalPixelPage;